"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageAlt = exports.composeGroupImageUrl = exports.composeCourseImageAssetUrl = void 0;
var _endpoints = require("./endpoints");
var composeGroupImageUrl = function composeGroupImageUrl(_ref) {
  var image = _ref.image,
    thumbnail = _ref.thumbnail;
  var groupImage = thumbnail || image || '';
  return (0, _endpoints.getCdnBucketImageUrl)(groupImage);
};

// max alt length for images should be around 100 characters for SEO
exports.composeGroupImageUrl = composeGroupImageUrl;
var getImageAlt = function getImageAlt(description) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return description.length > maxLength ? "".concat(description.substring(maxLength), "...") : description;
};
exports.getImageAlt = getImageAlt;
var composeCourseImageAssetUrl = function composeCourseImageAssetUrl(_ref2) {
  var image = _ref2.image,
    thumbnail = _ref2.thumbnail;
  var imageAsset = thumbnail || image || '';
  return (0, _endpoints.getCourseImageAssetUrl)(imageAsset);
};
exports.composeCourseImageAssetUrl = composeCourseImageAssetUrl;